/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlanDto } from '../../models/plan-dto';
import { UpdatePlanRequest } from '../../models/update-plan-request';

export interface BillingPlansPlanIdPut$Plain$Params {
  planId: string;
      body?: UpdatePlanRequest
}

export function billingPlansPlanIdPut$Plain(http: HttpClient, rootUrl: string, params: BillingPlansPlanIdPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<PlanDto>> {
  const rb = new RequestBuilder(rootUrl, billingPlansPlanIdPut$Plain.PATH, 'put');
  if (params) {
    rb.path('planId', params.planId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlanDto>;
    })
  );
}

billingPlansPlanIdPut$Plain.PATH = '/billing/plans/{planId}';
